module.exports = __webpack_public_path__ + "img/NE.5ddf9a55.svg";